import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import useLenis from "@/lib/useLenis";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";

export default function Layout() {
  useLenis();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="grain min-h-screen bg-cream">
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
